var OddsFormatOptions = /* @__PURE__ */ ((OddsFormatOptions2) => {
  OddsFormatOptions2[OddsFormatOptions2["ODDS_FORMAT_DECIMAL"] = 1] = "ODDS_FORMAT_DECIMAL";
  OddsFormatOptions2[OddsFormatOptions2["ODDS_FORMAT_AMERICAN"] = 2] = "ODDS_FORMAT_AMERICAN";
  OddsFormatOptions2[OddsFormatOptions2["ODDS_FORMAT_FRACTIONAL"] = 3] = "ODDS_FORMAT_FRACTIONAL";
  OddsFormatOptions2[OddsFormatOptions2["ODDS_FORMAT_MALAYSIAN"] = 4] = "ODDS_FORMAT_MALAYSIAN";
  OddsFormatOptions2[OddsFormatOptions2["ODDS_FORMAT_INDONESIAN"] = 5] = "ODDS_FORMAT_INDONESIAN";
  OddsFormatOptions2[OddsFormatOptions2["ODDS_FORMAT_HONG_KONG"] = 6] = "ODDS_FORMAT_HONG_KONG";
  return OddsFormatOptions2;
})(OddsFormatOptions || {});
var AsideGlobalSettingsType = /* @__PURE__ */ ((AsideGlobalSettingsType2) => {
  AsideGlobalSettingsType2["oddsFormat"] = "Odds format";
  AsideGlobalSettingsType2["acceptingBets"] = "Accepting Bets";
  AsideGlobalSettingsType2["betAmount"] = "Bet Amount";
  return AsideGlobalSettingsType2;
})(AsideGlobalSettingsType || {});
var OddsIndicationOptions = /* @__PURE__ */ ((OddsIndicationOptions2) => {
  OddsIndicationOptions2[OddsIndicationOptions2["ODD_INDICATION_FULL"] = 1] = "ODD_INDICATION_FULL";
  OddsIndicationOptions2[OddsIndicationOptions2["ODD_INDICATION_ARROW"] = 2] = "ODD_INDICATION_ARROW";
  return OddsIndicationOptions2;
})(OddsIndicationOptions || {});
var ChangeBettingOptions = /* @__PURE__ */ ((ChangeBettingOptions2) => {
  ChangeBettingOptions2[ChangeBettingOptions2["CHANGE_LIVE_NOTIFY_ALWAYS"] = 1] = "CHANGE_LIVE_NOTIFY_ALWAYS";
  ChangeBettingOptions2[ChangeBettingOptions2["CHANGE_LIVE_DOWN"] = 2] = "CHANGE_LIVE_DOWN";
  ChangeBettingOptions2[ChangeBettingOptions2["CHANGE_LIVE_ACCEPT"] = 3] = "CHANGE_LIVE_ACCEPT";
  return ChangeBettingOptions2;
})(ChangeBettingOptions || {});
var TfaOptions = /* @__PURE__ */ ((TfaOptions2) => {
  TfaOptions2[TfaOptions2["TFA_DASIBLED"] = 0] = "TFA_DASIBLED";
  TfaOptions2[TfaOptions2["TFA_EMAIL"] = 1] = "TFA_EMAIL";
  TfaOptions2[TfaOptions2["TFA_QRCODE"] = 3] = "TFA_QRCODE";
  return TfaOptions2;
})(TfaOptions || {});
var CustomerPreferencesNames = /* @__PURE__ */ ((CustomerPreferencesNames2) => {
  CustomerPreferencesNames2["changeLive"] = "changeLive";
  CustomerPreferencesNames2["timezone"] = "timezone";
  CustomerPreferencesNames2["odds_format"] = "odds_format";
  CustomerPreferencesNames2["time_format"] = "time_format";
  CustomerPreferencesNames2["odd_indication"] = "odd_indication";
  CustomerPreferencesNames2["display_balance"] = "display_balance";
  CustomerPreferencesNames2["phone_marketing_allowed"] = "phone_marketing_allowed";
  CustomerPreferencesNames2["email_marketing_allowed"] = "email_marketing_allowed";
  CustomerPreferencesNames2["madeBet"] = "madeBet";
  CustomerPreferencesNames2["tfa"] = "tfa";
  CustomerPreferencesNames2["qrCodeUrl"] = "qrCodeUrl";
  CustomerPreferencesNames2["hashCode"] = "hashCode";
  CustomerPreferencesNames2["password"] = "password";
  CustomerPreferencesNames2["tfaConfirmationCode"] = "tfaConfirmationCode";
  return CustomerPreferencesNames2;
})(CustomerPreferencesNames || {});
var displayBalance = /* @__PURE__ */ ((displayBalance2) => {
  displayBalance2[displayBalance2["show_balance"] = 1] = "show_balance";
  displayBalance2[displayBalance2["hide_balance"] = 0] = "hide_balance";
  return displayBalance2;
})(displayBalance || {});
var CustomerPreferencesEnum = /* @__PURE__ */ ((CustomerPreferencesEnum2) => {
  CustomerPreferencesEnum2["changeLive"] = "changeLive";
  CustomerPreferencesEnum2["timezone"] = "timezone";
  CustomerPreferencesEnum2["odds_format"] = "odds_format";
  CustomerPreferencesEnum2["time_format"] = "time_format";
  CustomerPreferencesEnum2["odd_indication"] = "odd_indication";
  CustomerPreferencesEnum2["display_balance"] = "display_balance";
  CustomerPreferencesEnum2["phone_marketing_allowed"] = "phone_marketing_allowed";
  CustomerPreferencesEnum2["email_marketing_allowed"] = "email_marketing_allowed";
  CustomerPreferencesEnum2["sms_marketing_allowed"] = "sms_marketing_allowed";
  CustomerPreferencesEnum2["calls_marketing_allowed"] = "calls_marketing_allowed";
  CustomerPreferencesEnum2["other_marketing_allowed"] = "other_marketing_allowed";
  CustomerPreferencesEnum2["madeBet"] = "madeBet";
  CustomerPreferencesEnum2["hiddenPublicStats"] = "hiddenPublicStats";
  CustomerPreferencesEnum2["tfa"] = "tfa";
  CustomerPreferencesEnum2["qrCodeUrl"] = "qrCodeUrl";
  CustomerPreferencesEnum2["hashCode"] = "hashCode";
  CustomerPreferencesEnum2["password"] = "password";
  CustomerPreferencesEnum2["tfaConfirmationCode"] = "tfaConfirmationCode";
  CustomerPreferencesEnum2["lastBetSumEnabled"] = "lastBetSumEnabled";
  CustomerPreferencesEnum2["quickBetEnabled"] = "quickBetEnabled";
  CustomerPreferencesEnum2["fastAmounts"] = "fastAmounts";
  CustomerPreferencesEnum2["quickBet"] = "quickBet";
  CustomerPreferencesEnum2["watchersChatEnabled"] = "watchersChatEnabled";
  CustomerPreferencesEnum2["watchersLastMessageShow"] = "watchersLastMessageShow";
  CustomerPreferencesEnum2["notificationsEnabled"] = "notificationsEnabled";
  CustomerPreferencesEnum2["accept_bonuses"] = "accept_bonuses";
  return CustomerPreferencesEnum2;
})(CustomerPreferencesEnum || {});
export {
  AsideGlobalSettingsType,
  ChangeBettingOptions,
  CustomerPreferencesEnum,
  CustomerPreferencesNames,
  OddsFormatOptions,
  OddsIndicationOptions,
  TfaOptions,
  displayBalance
};
